module.exports = __webpack_public_path__ + "img/share_q.b0828f19.png";